import { PictureAndDescription } from "./App";

export const picturesAndDescriptions: PictureAndDescription[] = [
    {
      path: "beanandplutoonthebed.HEIC",
      key: "beanandplutoonthebed",
      description: "Bean and Pluto cuddled together on the bed"
    },
    {
      path: "beanbeingsillyinbed.JPEG",
      key: "beanbeingsillyinbed",
      description: "Bean being silly and playful in bed"
    },
    {
      path: "beanchillinginthewindow.JPEG",
      key: "beanchillinginthewindow",
      description: "Bean relaxing and chilling in the window"
    },
    {
      path: "beancozyinbed.jpeg",
      key: "beancozyinbed",
      description: "Bean looking cozy and comfortable in bed"
    },
    {
      path: "beanneutral.jpeg",
      key: "beanneutral",
      description: "Bean with a neutral, calm expression"
    },
    {
      path: "beanonbedwithtoys.jpeg",
      key: "beanonbedwithtoys",
      description: "Bean on the bed surrounded by toys"
    },
    {
      path: "beansayinghi.jpeg",
      key: "beansayinghi",
      description: "Bean greeting and saying hi"
    },
    {
      path: "beanserious.jpeg",
      key: "beanserious",
      description: "Bean with a serious, focused expression"
    },
    {
      path: "beanseriouswithhat.jpeg",
      key: "beanseriouswithhat",
      description: "Bean looking serious while wearing a hat"
    },
    {
      path: "beansillywithhat.jpeg",
      key: "beansillywithhat",
      description: "Bean being silly while wearing a hat"
    },
    {
      path: "beanwearingshoes.jpeg",
      key: "beanwearingshoes",
      description: "Bean adorably wearing shoes"
    },
    {
      path: "beanwithpluto.jpeg",
      key: "beanwithpluto",
      description: "Bean hanging out with Pluto"
    },
    {
      path: "beanwithplutogreeting.jpeg",
      key: "beanwithplutogreeting",
      description: "Bean and Pluto greeting together"
    },
    {
      path: "beanwithtongueout.JPEG",
      key: "beanwithtongueout",
      description: "Bean with tongue sticking out, being goofy"
    },
    {
      path: "beanyawning.jpeg",
      key: "beanyawning",
      description: "Bean mid-yawn, looking sleepy"
    },
    {
      path: "beanoncabinetsideprofile.png",
      key: "beanoncabinetsideprofile",
      description: "Bean and Pluto standing together on top of the kitchen cabinet"
    },
    {
      path: "beanoncabinetexploring.png",
      key: "beanoncabinetexploring",
      description: "Pluto exploring the cabinet while Bean peeks from the side"
    },
    {
      path: "beanoncabinetstaring.png",
      key: "beanoncabinetstaring",
      description: "Bean staring directly at the camera with Pluto beside him on the cabinet"
    },
    {
      path: "beanandplutoincabinet.png",
      key: "beanandplutoincabinet",
      description: "Bean and Pluto hanging out together inside the upper cabinet nook"
    },
    {
      path: "beanoncabinetlookingleft.png",
      key: "beanoncabinetlookingleft",
      description: "Bean sitting high in the cabinet and looking off to the left"
    },
    {
      path: "beanoncabinetlookingdown.png",
      key: "beanoncabinetlookingdown",
      description: "Bean looking down curiously from the cabinet edge while Pluto lounges behind"
    },
    {
      path: "beanandplutoclosetogether.png",
      key: "beanandplutoclosetogether",
      description: "Bean and Pluto close together in the cabinet, both alert and watching"
    },
    {
      path: "beanandplutoincabinetposing.png",
      key: "beanandplutoincabinetposing",
      description: "Bean in front with Pluto behind, both posing together in the cabinet"
    },
    {
      path: "beanoncabinetloaf.png",
      key: "beanoncabinetloaf",
      description: "Bean loafed at the front edge of the cabinet with Pluto in the back"
    },
    {
      path: "beanoncabinetpeek.png",
      key: "beanoncabinetpeek",
      description: "Bean peeking over the front of the cabinet shelf with wide curious eyes"
    },
    {
      path: "beanundertablewide.png",
      key: "beanundertablewide",
      description: "Bean sitting under the glass table frame in the living room"
    },
    {
      path: "beanundertableportrait.png",
      key: "beanundertableportrait",
      description: "Bean portrait under the table with a calm, slightly serious expression"
    },
    {
      path: "beanundertablecloseup.png",
      key: "beanundertablecloseup",
      description: "Close-up of Bean under the table showing his fluffy tuxedo coat"
    }
  ];